import { render, staticRenderFns } from "./SDKListIUV.vue?vue&type=template&id=24acc47e&scoped=true"
import script from "./SDKListIUV.vue?vue&type=script&lang=js"
export * from "./SDKListIUV.vue?vue&type=script&lang=js"
import style0 from "./SDKListIUV.vue?vue&type=style&index=0&id=24acc47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24acc47e",
  null
  
)

export default component.exports